import { Utils } from './../../../../utils/Utils';
import {
  IFiatTransaction,
  WITHDRAW_TRANSACTION_STATUS,
} from './../../../../models/FiatTransaction';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../../abstraction/auth.service';
import { COIN } from '../../../../models/Order';
import { SecondWithdrawComponent } from './second-withdraw/second-withdraw.component';
import { DataLayerService } from '../../../../services/utils/data-layer.service';
import { ErrorHandlingService } from 'src/app/pages/core/services/utils/error-handling.service';
import { IBankAccount } from 'src/app/pages/core/models/User';
import { TransactionType } from 'src/app/pages/core/models/Transactions';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-withdraw-fiat',
  templateUrl: './withdraw-fiat.component.html',
  styleUrls: ['./withdraw-fiat.component.scss'],
})
export class WithdrawFiatComponent implements OnInit {
  @Input() type: number;

  amount: FormControl = new FormControl('');
  indexSelected: FormControl = new FormControl(0);
  addingAccount: boolean;
  successfulAccount: boolean;
  loadingWithdraw: boolean;
  successfulWithdraw: boolean;

  deleteBankAccountLoading = false;

  nameControl = new FormControl('', Validators.required);
  cbuControl = new FormControl('', [Validators.required]);
  pesosControl = new FormControl(false, Validators.required);
  dolaresControl = new FormControl(false, Validators.required);
  accountNotOwned = false;
  notTrueCoin = false;

  errorMsg = '';
  errorCode = '';

  bindDown = false;
  showReminderMessage = false;
  banksAccounts: IBankAccount[] = [];

  isWithdrawDisabled = false;

  public Coin = COIN;

  constructor(
    public dataService: DataLayerService,
    public dialogRef: MatDialogRef<WithdrawFiatComponent>,
    public matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: number,
    public authService: AuthService,
    private errorHandler: ErrorHandlingService,
    public router: Router,
  ) {
    this.amount.setValue('');
    this.addingAccount = false;
    this.loadingWithdraw = false;

    this.pesosControl.setValue(this.type ? true : false);
    this.dolaresControl.setValue(this.type ? false : true);
  }

  ngOnInit(): void {
    this.banksAccounts = this.authService.loggedUser.bankAccounts[
      this.type === 0 ? 'USD' : 'ARS'
    ]?.map((bankAccount: IBankAccount) => bankAccount);

    if (this.authService.userHistories.value.withdraws.length === 0) {
      this.authService.getUserHistories();
    }
    // MOSTRAR MENSAJE DE RECORDATORIO DESDE LAS 23 A 2am
    const currentHour = new Date().getHours();
    if (currentHour >= 23 || currentHour <= 2) {
      this.showReminderMessage = true;
    }

    this.authService.getFiatStatus().subscribe((res) => {
      if (res.length === 0) return;
      this.isWithdrawDisabled = !res.find((status) => {
        return status.type === TransactionType.WITHDRAW;
      })?.coins[this.type === 1 ? 'ARS' : 'USD'];
    });
  }

  setMaxAmount() {
    const value = this.parseFloatStringToCurrency(
      this.authService.loggedUser.balance.fiat[this.type === COIN.DOLAR ? 'USD' : 'ARS'] + '',
    );
    this.amount.setValue(value);
  }

  getBankName(account: IBankAccount): string {
    if (account.bankCode === '016') {
      return 'Mercado Pago';
    }
    return account.name || account.bankName;
  }

  imageBank(bankCode: string): string {
    if (bankCode === '016') {
      return '/assets/icons/psp/31.svg';
    }
    if (bankCode && bankCode !== '-') {
      return 'assets/icons/bank/' + Number(bankCode).toString() + '.svg';
    }
    return 'assets/icons/bank/default.svg';
  }

  addAccount() {
    if (this.invalidAddAccount()) {
      return;
    }
    if (this.addingAccount) {
      return;
    }

    this.pesosControl.setValue(this.type ? true : false);
    this.dolaresControl.setValue(this.type ? false : true);

    const cbu = this.cbuControl.value.split(' ').join('').split('/').join('').split('-').join('');

    if (this.pesosControl.value) {
      this.successfulAccount = false;
      this.addingAccount = true;
      this.authService.addAccount('ARS', cbu, this.nameControl.value.trim()).subscribe(
        (data) => {
          this.successfulAccount = true;
          setTimeout(() => {
            this.authService.loggedUser.bankAccounts[
              data.newAccount.coin === COIN.DOLAR ? 'USD' : 'ARS'
            ].push(data.newAccount);
            this.authService.saveUserToLocalStorage();
            this.cleanUpForm();
            this.addingAccount = false;
            this.successfulAccount = false;
            if (data.newAccount.coin !== COIN.PESO) {
              this.notTrueCoin = true;
            } else {
              this.indexSelected.setValue(
                this.authService.loggedUser.bankAccounts[
                  data.newAccount.coin === COIN.DOLAR ? 'USD' : 'ARS'
                ].length - 1,
              );
              this.dataService.withdrawStep = 1;
            }
          }, 500);
        },
        (err) => {
          this.addingAccount = false;
          if (err.error === 2) {
            this.bindDown = true;
          } else {
            this.accountNotOwned = true;
          }
        },
      );
    }

    if (this.dolaresControl.value) {
      this.addingAccount = true;
      this.authService.saveAccount('USD', cbu, this.nameControl.value).subscribe(
        (data) => {
          this.authService.loggedUser.bankAccounts[
            data.newAccount.coin === COIN.DOLAR ? 'USD' : 'ARS'
          ].push(data.newAccount);
          this.authService.saveUserToLocalStorage();
          this.cleanUpForm();
          this.addingAccount = false;
          if (data.newAccount.coin !== COIN.DOLAR) {
            this.notTrueCoin = true;
          } else {
            this.indexSelected.setValue(
              this.authService.loggedUser.bankAccounts[
                data.newAccount.coin === COIN.DOLAR ? 'USD' : 'ARS'
              ].length - 1,
            );
            this.dataService.withdrawStep = 1;
          }
        },
        (err) => {
          this.addingAccount = false;
          if (err.error === 2) {
            this.bindDown = true;
          } else {
            this.accountNotOwned = true;
          }
        },
      );
    }
  }

  withdraw() {
    this.errorMsg = '';
    if (this.loadingWithdraw || this.isWithdrawDisabled) {
      return;
    }
    if (Utils.parseCurrencryToNumber(this.amount.value) === 0) {
      if (
        this.authService.loggedUser.balance.fiat[this.type === COIN.DOLAR ? 'USD' : 'ARS'] === 0
      ) {
        this.errorMsg = 'No puede retirar debido a que no tiene balance.';
      } else {
        this.errorMsg = 'Debe ingresar el importe a retirar.';
      }
      return;
    } else if (
      Utils.parseCurrencryToNumber(this.amount.value) >
      this.authService.loggedUser.balance.fiat[this.type === COIN.DOLAR ? 'USD' : 'ARS']
    ) {
      this.errorMsg = 'El importe es mayor a lo que tiene en su balance';
      return;
    }
    if (
      this.authService.loggedUser.bankAccounts[this.type === COIN.DOLAR ? 'USD' : 'ARS'].length ===
      0
    ) {
      this.errorMsg = 'Debe crear una cuenta para retirar.';
      return;
    }

    this.loadingWithdraw = true;
    this.successfulWithdraw = false;

    if (this.type === 0) {
      if (this.authService.loggedUser.bankAccounts.USD.every((acc) => Boolean(acc.cbu))) {
        const actualMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const withdrawThisMonth = this.authService.userHistories.value.withdraws.filter(
          (withdraw: IFiatTransaction) =>
            actualMonth === new Date(withdraw.creationTime).getMonth() + 1 &&
            currentYear === new Date(withdraw.creationTime).getFullYear() &&
            withdraw.coin === 'USD' &&
            withdraw.status === WITHDRAW_TRANSACTION_STATUS.EXECUTED &&
            withdraw.destAccount?.cbu &&
            this.authService.loggedUser.bankAccounts.USD[this.indexSelected.value].cbu ===
              withdraw.destAccount.cbu,
        );

        if (withdrawThisMonth.length) {
          const dialogRef = this.matDialog
            .open(SecondWithdrawComponent, {
              panelClass: 'modal-container',
              minWidth: 'fit-content',
            })
            .afterClosed()
            .subscribe((res: boolean) => {
              if (res) {
                this.withdrawFiat();
              } else {
                this.loadingWithdraw = false;
              }
            });
        } else {
          this.withdrawFiat();
        }
      } else {
        this.withdrawFiat();
      }
    } else if (this.type === 1) {
      this.withdrawFiat();
    }
  }

  withdrawFiat() {
    const fiatType = this.type ? 'ARS' : 'USD';
    const amount = Utils.parseCurrencryToNumber(this.amount.value);
    this.authService.withdrawFiat(fiatType, this.indexSelected.value, amount).subscribe(
      (data) => {
        this.loadingWithdraw = true;
        this.successfulWithdraw = true;
        this.loadingWithdraw = false;
        this.successfulWithdraw = false;

        this.dialogRef.close();
        this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: '¡Solicitud de retiro creado!',
            content: `Tu solicitud de retiro se está procesando, en instantes lo verás reflejado en tu cuenta.`,
          },
        });
      },
      (error) => {
        const err = this.errorHandler.handleErrorFiatWithdrawals(error);
        console.log('Withdraw Error', error);
        this.loadingWithdraw = false;
        this.successfulWithdraw = false;
        this.errorMsg = err.errorMsg;
        this.errorCode = err.errorCode;
      },
    );
  }

  invalidAddAccount(): boolean {
    this.nameControl.markAsDirty();
    this.pesosControl.markAsDirty();
    this.dolaresControl.markAsDirty();
    this.cbuControl.markAsDirty();
    return (
      this.accountNotOwned ||
      this.nameControl.hasError('required') ||
      this.cbuControl.hasError('required') ||
      this.cbuControl.hasError('minlength') ||
      (this.pesosControl.hasError('required') && this.dolaresControl.hasError('required'))
    );
    // && !this.usernameControl.hasError('required');
  }

  cleanUpForm() {
    this.nameControl.reset();
    this.cbuControl.reset();
    this.pesosControl.reset();
    this.dolaresControl.reset();
    this.pesosControl.setValue(this.type ? true : false);
    this.dolaresControl.setValue(this.type ? false : true);
  }

  cleanErrors() {
    this.accountNotOwned = false;
    this.notTrueCoin = false;
  }

  getErrorMessage(input) {
    switch (input) {
      case 'cbu': {
        return this.cbuControl.hasError('required')
          ? 'Este campo es obligatorio'
          : this.cbuControl.hasError('minlength')
          ? 'Este campo esta incompleto'
          : '';
      }
      case 'name': {
        return this.nameControl.hasError('required') ? 'Este campo es obligatorio' : '';
      }
      case 'checkboxes': {
        return 'Se debe elegir si es una cuenta en pesos y/o dólares';
      }
      default: {
        return 'Hubo un error en el proceso.';
      }
    }
  }
  parseFloatStringToCurrency(numberStr: string): string {
    if (!numberStr) {
      return '0';
    }
    if (parseFloat(numberStr) % 1 === 0) {
      numberStr = numberStr + '.00';
    }
    const arr = numberStr.split('.');
    if (arr.length > 1) {
      arr[1] = arr[1].substr(0, 2);
    }
    arr[0] = arr[0]
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g)
      .join('.')
      .split('')
      .reverse()
      .join('');
    return arr.join(',');
  }

  bankIconErrorHandler(imgElement: HTMLImageElement) {
    imgElement.src = '/assets/icons/bank/default.svg';
  }
}
